import { Injectable } from '@angular/core';
import { TranslateMessageFormatCompiler } from 'ngx-translate-messageformat-compiler';

@Injectable()
export class SharedTranslateCompilerService extends TranslateMessageFormatCompiler {

  public override compile(value: string | { [key: string]: string }, lang: string): any {
    if (typeof value === "string") {
      return super.compile(value, lang);
    }

    // @ts-ignore
    return (param: any) => {
      const paramKey = param && Object.keys(param)[0];
      const firstParam = param && param[paramKey];

      let pluralValue;

      switch (true) {
        // @ts-ignore
        case firstParam === 0:
          if (value['zero']) {
            pluralValue = value['zero'];
            break;
          }
        // @ts-ignore
        case firstParam === 1:
          if (value['one']) {
            pluralValue = value['one'];
            break;
          }
        // @ts-ignore
        case firstParam === 2:
          if (value['two']) {
            pluralValue = value['two'];
            break;
          }

        // @ts-ignore
        case firstParam > 1 && firstParam < 5:
          if (value['few']) {
            pluralValue = value['few'];
            break;
          }
        default:
          const other = value['other'] || value['many'];
          if (other) {
            pluralValue = other;
            break;
          }
      }

      const firstKey = Object.keys(value)[0];
      const translationValue = pluralValue || value[firstKey];
      return super.compile(translationValue, lang)(param);
    };
  }

  public override compileTranslations(translations: any, lang: string): any {
    if (typeof translations === 'string') {
      return this.compile(translations, lang);
    }

    const groupedKeys = Object.keys(translations).reduce((total, key) => {
      const isPlural = key.match(/^(([A-Za-z0-9\-_]+)\.){2,}(zero|one|two|few|many|other)$/);
      const keyValue = translations[key];

      if (isPlural) {
        const keyPrefix = key.substring(0, key.lastIndexOf('.'));
        const keySuffix = key.replace(`${keyPrefix}.`, '');

        if (!total[keyPrefix] || typeof total[keyPrefix] !== 'object') {
          total[keyPrefix] = {};
        }

        total[keyPrefix][keySuffix] = keyValue;
      } else {
        total[key] = keyValue;
      }
      return total;
    }, {} as Record<string, any>);

    // Instead of compiling now, return lazy wrappers
    return Object.keys(groupedKeys).reduce((acc, key) => {
      const rawValue = groupedKeys[key];

      acc[key] = (params?: any) => {
        // If not compiled yet, compile and cache
        if (typeof rawValue === 'function') {
          // already compiled
          return rawValue(params);
        }

        const compiledFn = this.compile(rawValue, lang);
        // Replace with compiled version for next time
        acc[key] = compiledFn;
        return compiledFn(params);
      };

      return acc;
    }, {} as Record<string, any>);
  }

}
